import { BusinessEntity } from './contentPage';

export enum PermissionType {
    Create = 'Create',
    Read = 'Read',
    Update = 'Update',
    Delete = 'Delete',
}

export interface IPermission {
    businessEntity: BusinessEntity;
    permissionType: PermissionType;
}

export interface IRoleWriteModel {
    name: string;
    permissions: IPermission[];
}

export interface IRoleReadModel extends IRoleWriteModel {
    readonly id: number;
    readonly tenantId: string;
}

export type InternalPermissionsDict = Record<string, Record<PermissionType, boolean>>;

export const noPortalAccessRoleId = -1;